import {createStyles, Theme} from "@material-ui/core";
import {beigeColor, styleColors} from "src/main.style";

export const CampaignContainerStyle = (theme: Theme) =>
  createStyles({
    contentBox : {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      padding: '20px',
      backgroundColor: styleColors.lightBeige,
      gap: '20px',
      margin: '20px',
      borderRadius: '20px',
      textAlign: 'center',
      marginTop:'50px',
    },
    root: {
      width: '100%',
      position: 'relative',

      '& > *': {
          boxSizing: "border-box",
      },
    },
    background: {
        position: 'absolute',
        overflow: 'hidden',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        minHeight: '100vh',
        zIndex: -1,
        backgroundColor: theme.palette.background.default,
    },
    backgroundImgCornerTopRight: {
        position: 'absolute',
        top: 0,
        right: 0,
    },
    circle: {
        zIndex: 0,
        position: 'absolute',
        top: '-17.125rem',
        left: '-30.75rem',
        width: '56.25rem',
        height: '56.25rem',
        borderRadius: '56.25rem',
        backgroundColor: beigeColor,

        [theme.breakpoints.up('md')]: {
            display: 'none',
        },
    },
    container: {
        width: '100%',
        minHeight: '100vh',
        display: 'flex',
        flexDirection: 'column',
        padding: theme.spacing(6.5),
    },
    topContent: {
      display: 'flex',
      flexDirection: 'column',
      gap: theme.spacing(2),
      marginTop: theme.spacing(2.5),
      marginBottom: theme.spacing(2.5),
    },
    centerContent: {
        flex: 1,
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
    },
    formMiddleContent: {
      display: 'flex',
      flexDirection: 'column',
      gap: theme.spacing(2.5),
      marginBottom: theme.spacing(1),
    },
    formBottomContent: {
        display: 'flex',
        flexDirection: 'column',
        gap: theme.spacing(2.5),
    },
    checkmarkPane: {
      position: 'absolute',
      top: 0,
      left: 0,
      width: '100%',
      height: '100%',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      zIndex: 1.
    }
  });



// WEBPACK FOOTER //
// ./src/containers/campaign/campaign.style.ts